import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ArabicDatePipe } from 'src/app/shared/pipes/arabic-date-pipe.pipe';
import { HijriDatePipe } from 'src/app/shared/pipes/hijri-date';
import { GregorianUserDataInputComponent } from './gregorian-user-data-input.component';
import { HijriUserDataInputComponent } from './hijri-user-data-input.component';

@NgModule({
  declarations: [HijriUserDataInputComponent, GregorianUserDataInputComponent],
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatRadioModule, MatMomentDateModule],
  exports: [HijriUserDataInputComponent, GregorianUserDataInputComponent],
  providers: [ArabicDatePipe, HijriDatePipe]
})
export class UserDataInputModule {}
